import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, mergeProps as _mergeProps, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['map-card'])
}
const _hoisted_2 = { class: "flexRow items-end lot-top-block" }
const _hoisted_3 = { class: "lotid-title" }
const _hoisted_4 = {
  key: 0,
  class: "location-block"
}
const _hoisted_5 = { class: "location-block-title wo-line" }
const _hoisted_6 = { class: "location-block-icon" }
const _hoisted_7 = { class: "location-block-title font-semibold" }
const _hoisted_8 = {
  key: 1,
  class: "lotinfo-mktitle"
}
const _hoisted_9 = {
  key: 0,
  class: "tabs"
}
const _hoisted_10 = {
  type: "radio",
  name: "tabs",
  id: "tabone",
  checked: ""
}
const _hoisted_11 = { for: "tabone" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "tab"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flexDiv mb-5 mt-5" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "price-block" }
const _hoisted_21 = {
  key: 0,
  class: "price-block-panel-text"
}
const _hoisted_22 = { class: "price-block-panel" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "amenities-list mb-8" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { key: 5 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = {
  key: 0,
  class: "carousel-navigation"
}
const _hoisted_50 = { for: "tabtwo" }
const _hoisted_51 = {
  key: 1,
  class: "tab site-photo"
}
const _hoisted_52 = { class: "tab-slider relative" }
const _hoisted_53 = {
  key: 0,
  class: "slider-caption"
}
const _hoisted_54 = {
  key: 0,
  class: "carousel-navigation"
}
const _hoisted_55 = { class: "flexDiv" }
const _hoisted_56 = { class: "homePlan-name green" }
const _hoisted_57 = { class: "amenities-list" }
const _hoisted_58 = {
  key: 0,
  class: "location-block-date"
}
const _hoisted_59 = {
  type: "radio",
  name: "tabs",
  id: "tabone",
  checked: ""
}
const _hoisted_60 = { for: "tabone" }
const _hoisted_61 = {
  key: 0,
  class: "flexDiv"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "tab-slider" }
const _hoisted_64 = {
  key: 0,
  class: "slider-caption"
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 0,
  class: "carousel-navigation"
}
const _hoisted_67 = {
  key: 1,
  class: "flexDiv mb-5"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "price-block" }
const _hoisted_71 = {
  key: 0,
  class: "price-block-panel"
}
const _hoisted_72 = {
  key: 0,
  class: "understrike"
}
const _hoisted_73 = { class: "amenities-list mb-8" }
const _hoisted_74 = {
  key: 0,
  class: "under-construction-list"
}
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 2 }
const _hoisted_77 = { key: 3 }
const _hoisted_78 = { key: 4 }
const _hoisted_79 = { key: 5 }
const _hoisted_80 = { key: 6 }
const _hoisted_81 = { for: "tabtwo" }
const _hoisted_82 = { class: "tab site-photo" }
const _hoisted_83 = { class: "tab-slider relative" }
const _hoisted_84 = {
  key: 0,
  class: "slider-caption"
}
const _hoisted_85 = {
  key: 0,
  class: "carousel-navigation"
}
const _hoisted_86 = { class: "flexDiv" }
const _hoisted_87 = { class: "homePlan-name green" }
const _hoisted_88 = { class: "amenities-list" }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "sold" }
const _hoisted_92 = { class: "homePlan-name mb-8" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = {
  key: 0,
  class: "tab"
}
const _hoisted_95 = { class: "tab-slider" }
const _hoisted_96 = {
  key: 3,
  class: "soldHomes-msg",
  id: "mobileText"
}
const _hoisted_97 = { key: 1 }

import {
  ref,
  reactive,
  computed,
  watch,
  onMounted,
  onUpdated,
  onBeforeUnmount,
  nextTick,
  toRefs,
  inject,
} from 'vue';
import lodash from 'lodash';
import { isMobile, isTablet, isIE } from 'mobile-device-detect';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import LazyImage from './../LazyImage.vue';
import { apiFetchLotInfo } from '../../api';
import {
  HomesPlan,
  LotDetail,
  LotInfo,
  LotPosition,
  NeighborhoodInfo,
} from './../../types';
import {
  Status,
  ModalType,
  Scalers,
  LinkOpenConatactInfo,
} from './../../constant';
import Location from '@/assets/icons/Location.vue';
import {
  calcZoom,
  formatPrice,
  getPlatMapModalPosition,
  convertToTitleCase,
  getTouchesCenter,
  getZoomDistance,
  addImageScaler,
} from './../../core';
import { apiMessages } from '../../api/message-api';
import SoldPendingStatus from '@/assets/icons/SoldPendingStatus.vue';
import SoldContengencyStatus from '@/assets/icons/SoldContengencyStatus.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapModal',
  props: {
    lotId: {},
    position: {},
    isKioskMode: { type: Boolean },
    selectedNeighborhoodIds: {},
    neighborhoods: {},
    zoomLevel: {},
    underlay: { type: Boolean }
  },
  emits: ["showPlanFutureLotFlyout", "openModal", "calculateContactInfoTopPosition", "updateLotPosition", "handlePrintSelectionClick", "updateLotInfo", "closeLotInfo"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const {
  lotId,
  position,
  isKioskMode,
  selectedNeighborhoodIds,
  neighborhoods,
  zoomLevel,
  underlay,
} = toRefs(props);
const emit = __emit;

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));
const availableStatus = Status;
const lotInfo = ref<LotInfo>({} as LotInfo);
const lotPosition = ref<LotPosition>({} as LotPosition);
const hasMobile = ref(!!(isMobile && !isTablet));
const hasTablet = ref(isTablet);
const errorMessage = ref('');
const loading = ref(isIE);
const messages = ref<any>({});
const trailingText = ref<string[]>([]);
const linkOpenConatactInfo = LinkOpenConatactInfo;
const zoom = ref(1);
const zoomCenter = ref({ x: 0, y: 0 });
const lastDistance = ref(0);
const width = ref(window.innerWidth);
const height = ref(window.innerHeight);
const lastX = ref<number | null>(null);
const lastY = ref<number | null>(null);
const x = ref(0);
const y = ref(0);
const transition = ref({
  transform: null as any,
  origin: 'transform-origin 400ms linear' as any,
});
const sliderOptions = ref({
  itemsToShow: 1,
});
const minZoom = ref(1);
const maxZoom = ref(10);
const minZoomBounce = ref(0.015);
const maxZoomBounce = ref(0.015);
const speed = ref(0.5);
const showDefaultImage = ref(false);
const slick = ref<any>(null);
const siteSlick = ref<any>(null);
const baseElement = ref<any>(null);

const mode = inject('mode', ref(''));

watch(lotId, async (val, oldVal) => {
  if (val !== oldVal) {
    resetZoom();
    await fetchLotInfo();
    if (!underlay.value) resetModalTop();
  }
});

watch(selectedNeighborhoodIds, (val, oldVal) => {
  if (val !== oldVal) emit('closeLotInfo');
});

watch(
  position,
  (val, oldVal) => {
    if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
      lotPosition.value = val;
    }
  },
  { deep: true }
);

const showHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans?.length &&
    [availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot?.status
    )
);

const isShowModalAboveArrowUnderlay = computed(
  () =>
    !underlay.value &&
    (hasMobile.value || hasTablet.value) &&
    lotPosition.value.positionModal === 'below'
);

const isShowModalDownArrowUnderlay = computed(
  () =>
    !underlay.value &&
    (hasMobile.value || hasTablet.value) &&
    lotPosition.value.positionModal === 'above'
);

const lotStatus = computed(() => {
  let status = lotInfo.value.lot?.status;
  if ([availableStatus.QUICK_MOVE_IN, availableStatus.QMI].includes(status))
    status = 'qmi';
  else if (
    [
      availableStatus.SOLD,
      availableStatus.SOLD_CLOSED,
      availableStatus.SOLD_CONTINGENCY,
      availableStatus.SOLD_PENDING,
      availableStatus.AVAILABLE,
    ].includes(status)
  )
    status = status.toLowerCase();
  return status;
});

const showFutureHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans?.length &&
    [availableStatus.FUTURE_HOME].includes(lotInfo.value.lot?.status)
);

const zoomStyles = computed(() => {
  let t = '';
  if (transition.value.transform) t += transition.value.transform;
  if (transition.value.origin)
    t += (t.length > 0 ? ', ' : '') + transition.value.origin;
  return {
    transform: `scale(${zoom.value}) translate3d(${x.value}px, ${y.value}px, 0px)`,
    transition: t,
  };
});

onMounted(async () => {
  lotPosition.value = position.value;
  await fetchLotInfo();
  if (!underlay.value) resetModalTop();
});

onUpdated(() => {
  nextTick(() => {
    if (isIE) loading.value = false;
    if (Object.keys(lotInfo.value).length && !isMobile && !isTablet) {
      updateModalPosition();
    }
  });
});

onBeforeUnmount(() => {
  const el = baseElement.value as HTMLElement | undefined;
  if (el) {
    el.removeEventListener('touchstart', start);
    el.removeEventListener('touchmove', move);
    el.removeEventListener('touchend', end);
  }
  if (!underlay.value && hasMobile.value) {
    document.querySelector('.embtoolbox')?.classList.toggle('mobhide');
    document.querySelector('.mobile-legends')?.classList.toggle('mobhide');
    document.querySelector('.cp-filter')?.classList.toggle('mobhide');
  }
});

function resetModalTop() {
  if (
    lotInfo.value &&
    lotPosition.value.positionModal === 'above' &&
    (!lotInfo.value.homes_plans.length ||
      !lotInfo.value.homes_plans[0].image_url?.length)
  ) {
    lotPosition.value.top += 230;
  }
}

async function fetchLotInfo() {
  lotInfo.value = {} as LotInfo;
  let lotNeighborhood = '';
  let currentLotNeighborhoodId = lotId.value.split('-')[0];
  const data = await apiFetchLotInfo(
    currentLotNeighborhoodId,
    lotId.value,
    mode.value
  );
  if (data.result.lot.id === lotId.value) {
    lotNeighborhood =
      neighborhoods.value.find(
        (n) => n.neighborhood_code === currentLotNeighborhoodId
      )?.marketing_name || '';
    if (data.message) {
      errorMessage.value = 'Information for this lot is not yet available';
    } else {
      lotInfo.value = data.result;
      lotInfo.value.neighborhoodName = lotNeighborhood;
      errorMessage.value = '';
      emit('showPlanFutureLotFlyout', {
        lotInfo: lotInfo.value,
        lotId: lotId.value,
      });
    }
  }
  emit('updateLotInfo', {
    lotInfo: lotInfo.value,
    lotId: lotId.value,
    isFromModal: true,
  });
}

function resetZoom() {
  zoom.value = 1;
  zoomCenter.value.x = 0;
  zoomCenter.value.y = 0;
  x.value = 0;
  y.value = 0;
}
async function loadMessages() {
  const { messages: msg } = await apiMessages('PlatMapModal');
  messages.value = msg;
  trailingText.value =
    messages.value.soldHomesMessage.split(linkOpenConatactInfo);
}

function handleReInit() {
  nextTick(() => {
    (slick.value as any)?.reSlick();
  });
}

const isSiteTabActive = ref(false);

function handleSiteReInit() {
  isSiteTabActive.value = true;
  nextTick(() => {
    (siteSlick.value as any)?.slideTo(0);
  });
}

function beforeClose() {
  lotInfo.value = {} as LotInfo;
  const timer = setTimeout(() => {
    emit('closeLotInfo');
    clearTimeout(timer);
  }, 10);
}
const formatPriceFn = (value: number) => {
  return formatPrice(value);
};

const formatSquareFeet = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatDate = (moveInDate: string) => {
  const date = new Date(moveInDate);
  const formattedDate = date.toDateString().split(' ');
  return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
};

const openPlanDetails = (planURL: string) => {
  window.open(`${planURL}`, `HomePlans_WindowName`);
};

const openKioskPlanView = (planCode: string) => {
  // console.log('PlatMapModal...');
  // console.log('planCode = ' + planCode);
  // console.log('jobNumber? = ' + lotInfo.value.lot.id);
  // console.log('nbCode?: ' + lotId.value.split("-")[0]);
  // console.log('selectedneighborhoodIds:');
  // console.log(JSON.stringify(selectedNeighborhoodIds.value));
  console.log('lotInfo = ');
  console.log(JSON.stringify(lotInfo.value) || 'no lotinfo');
  let nbCode = lotInfo.value.lot.id.split("-")[0] || '';
  let pCode = planCode || '';
  let kioskPlanLink = `${process.env.VUE_APP_KIOSK_URL}planView?`;
  if (lotStatus.value === Status.AVAILABLE.toLowerCase()) {
    kioskPlanLink += `plan_code=${pCode}&neighborhood_code=${nbCode}`;
    console.log('kioskPlanLink 1: ' + kioskPlanLink);
  } else if (lotStatus.value === 'qmi') {
    kioskPlanLink += `job_number=${lotInfo.value.lot.id}&neighborhood_code=${nbCode}`;
    console.log('kioskPlanLink 2: ' + kioskPlanLink);
  }
  window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
};

const openContactInfo = () => {
  emit('calculateContactInfoTopPosition');
  emit('handlePrintSelectionClick', {
    printOptionSelected: false,
    showHomeLevel: false,
    actualLevels: [],
    selectedLevel: '',
  });
  emit('closeLotInfo');
  emit('openModal', ModalType.CONTACT_INFO);
};
const isRange = (val_low: number | null, val_high: number | null) => {
  return val_low != null && val_low != val_high && !!val_high && !!val_low;
};

const isRangeHalfBath = (val_low: number | null, val_high: number | null) =>
  val_low != null && val_high != null && val_high != 0 && val_low != val_high;

const suppressScheduleVisit = () => {
  return (
    [
      Status.SOLD,
      Status.SOLD_CLOSED,
      Status.SOLD_CONTINGENCY,
      Status.SOLD_PENDING,
      Status.RESERVED,
      Status.RESERVED_LOT_HOLD,
      Status.FUTURE_HOME,
    ].includes(lotInfo.value?.lot?.status) || isKioskMode.value
  );
};

const NTER_NOW_URL_PATTERN = /^https?:\/\//i;

/**
 * NterNow self-guided tour link for a Quick Move-In home. Empty unless the QMI
 * publishes a usable link and the Schedule a Visit CTA would otherwise show.
 */
const selfGuidedTourUrl = computed(() => {
  if (isSalesOrLandView.value || suppressScheduleVisit()) return '';
  if (![Status.QMI, Status.QUICK_MOVE_IN].includes(lotInfo.value?.lot?.status))
    return '';

  const nterNowUrl = lotInfo.value?.homes_plans?.[0]?.nter_now_url?.trim() ?? '';
  return NTER_NOW_URL_PATTERN.test(nterNowUrl) ? nterNowUrl : '';
});

const openSelfGuidedTour = () => {
  window.open(selfGuidedTourUrl.value, '_blank');
};

const showSoldMessage = computed(() => {
  return (
    [
      Status.SOLD,
      Status.SOLD_CLOSED,
      Status.SOLD_CONTINGENCY,
      Status.SOLD_PENDING,
      Status.FUTURE_HOME,
    ].includes(lotInfo.value?.lot?.status) || isKioskMode.value
  );
});

const bottomArrowCondition = (xPosition: string, yPosition: string) => {
  return (
    !hasMobile.value &&
    !hasTablet.value &&
    lotPosition.value?.xPosition === xPosition &&
    lotPosition.value?.yPosition === yPosition
  );
};

const imageSource = (src: any) => {
  if (typeof src === 'object' && src.image_url) {
    return addScaler(src.image_url);
  } else {
    showDefaultImage.value = true;
    return require('@/assets/images/home-not-available.png');
  }
};

const addScaler = (url: string) => {
  return addImageScaler(url);
};

const checkLowRange = (
  property1: keyof HomesPlan,
  property2: keyof HomesPlan,
  homePlan: HomesPlan
) => {
  const status = lotInfo.value?.lot?.status;
  return (
    (![Status.AVAILABLE, Status.FUTURE_HOME].includes(status) &&
      homePlan[property1] != null &&
      homePlan[property1]) ||
    ([Status.AVAILABLE, Status.FUTURE_HOME].includes(status) &&
      homePlan[property1] !== homePlan[property2] &&
      homePlan[property1])
  );
};
const checkLowRangeHalfBath = (
  property1: string,
  property2: string,
  homePlan: HomesPlan
) => {
  return (
    (![availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != null) ||
    ([availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != homePlan[property2] &&
      homePlan[property1] != null)
  );
};

const updateModalPosition = () => {
  const lotElement = document.getElementById(lotId.value) as HTMLElement | null;
  const modelContainer = document.getElementById(
    'platmap-modal'
  ) as HTMLElement | null;
  if (!lotElement || !modelContainer) return;

  const elementPosition = lotElement.getBoundingClientRect();
  const lotPos = getPlatMapModalPosition(
    elementPosition,
    modelContainer.clientHeight,
    zoomLevel.value
  );

  if (!lodash.isEqual(lotPosition.value, lotPos)) {
    emit('updateLotPosition', lotPos);
  }
};

const start = (event: TouchEvent) => {
  if (event.touches.length === 2) {
    handlePinchStart(event);
  }
};

const handlePinchStart = (event: TouchEvent) => {
  const { x, y } = getTouchCenter(
    getTouchesCenter(event.touches[0], event.touches[1])
  );
  if (zoom.value < maxZoom.value) {
    zoomCenter.value.x = x;
    zoomCenter.value.y = y;
  }
  lastDistance.value = getZoomDistance(event.touches[0], event.touches[1]);
};

const getTouchCenter = ({ x: cx, y: cy }: { x: number; y: number }) => {
  const rect = baseElement.value?.getBoundingClientRect();
  if (!rect) return { x: 0, y: 0 };
  return {
    x: cx - rect.left,
    y: cy - rect.top,
  };
};

const move = (event: TouchEvent) => {
  if (event.touches.length === 2) {
    handlePinchMove(event);
  } else {
    handlePanMove(event);
  }
};

const handlePinchMove = (event: TouchEvent) => {
  const dist = getZoomDistance(event.touches[0], event.touches[1]);
  const last = dist / lastDistance.value;
  const scale = calcZoom(
    minZoom.value - minZoomBounce.value,
    maxZoom.value + maxZoomBounce.value,
    zoom.value * last
  );

  if (
    zoom.value < maxZoom.value ||
    (zoom.value >= maxZoom.value && scale < zoom.value)
  ) {
    zoom.value = scale;
  }
  lastDistance.value = dist;
};

const checkRangeAndFutureHome = (homePlan: HomesPlan) => {
  return (
    isRange(homePlan.price_low, homePlan.price_high) &&
    lotInfo.value?.lot?.status !== availableStatus.FUTURE_HOME
  );
};

const handlePanMove = (event: TouchEvent) => {
  if (zoom.value > 1) {
    const touch = event.touches[0];
    const cx = touch.clientX;
    const cy = touch.clientY;

    if (!lastX.value || !lastY.value) {
      lastX.value = cx;
      lastY.value = cy;
      return;
    }

    const rect = baseElement.value?.getBoundingClientRect();
    if (!rect) return;

    let diffX = (cx - lastX.value) * speed.value;
    let diffY = (cy - lastY.value) * speed.value;

    transition.value.transform = null;

    x.value += diffX;
    y.value += diffY;

    // bounds
    if (rect.left > 0 && diffX > 0) x.value -= diffX;
    if (rect.right < width.value && diffX < 0) x.value -= diffX;
    if (rect.top > 0 && diffY > 0) y.value -= diffY;
    if (rect.bottom < height.value && diffY < 0) y.value -= diffY;

    // next move
    lastX.value = cx;
    lastY.value = cy;
  }
};

const end = (event: TouchEvent) => {
  if (zoom.value <= minZoom.value) {
    resetZoom();
  } else {
    lastX.value = 0;
    lastY.value = 0;
  }
};
__expose({
  beforeClose,
});

onMounted(() => {
  loadMessages();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _mergeProps({
      id: "platmap-modal",
      class: "embinfobox basic",
      style: [
        {
          top: `${lotPosition.value ? lotPosition.value.top + 'px' : 'auto'}`,
          left: `${
            lotPosition.value
              ? (_unref(zoomLevel) > 18 || !_unref(underlay)
                  ? lotPosition.value.left
                  : lotPosition.value.left + 25) + 'px'
              : 'auto'
          }`,
        },
        zoomStyles.value,
      ],
      ref_key: "baseElement",
      ref: baseElement
    }, _toHandlers(
        _unref(isKioskMode)
          ? { touchstart: start, touchmove: move, touchend: end }
          : undefined
      , true)), [
      (isShowModalAboveArrowUnderlay.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle([{ left: `${lotPosition.value.arrowPosition}px` }]),
            class: "arrow-pointer arrow-top-underlay"
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("i", {
          "aria-label": "close icon",
          class: "emb_closeicon",
          onClick: beforeClose
        }),
        (!_unref(lodash).isEmpty(lotInfo.value))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["map-card-body", lotStatus.value])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flexCol mb-4", lotStatus.value])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h3", _hoisted_3, "Site " + _toDisplayString(_unref(lotId)), 1),
                  _createElementVNode("span", {
                    class: "lotinfo-colors",
                    style: _normalizeStyle({ color: lotInfo.value.lot.color })
                  }, [
                    (lotInfo.value.lot.status === 'Sold Pending')
                      ? (_openBlock(), _createBlock(SoldPendingStatus, {
                          key: 0,
                          svgClass: "dsize"
                        }))
                      : (lotInfo.value.lot.status === 'Sold Contingency')
                        ? (_openBlock(), _createBlock(SoldContengencyStatus, {
                            key: 1,
                            svgClass: "dsize"
                          }))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 2,
                            style: _normalizeStyle({ backgroundColor: lotInfo.value.lot.color }),
                            class: "dsize"
                          }, null, 4)),
                    _createTextVNode(" " + _toDisplayString(lotInfo.value.lot.status === 'QMI' ? 'Quick Move-In' : lotInfo.value.lot.status), 1)
                  ], 4)
                ]),
                (lotInfo.value.lot.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(lotInfo.value.lot.address), 1),
                      _createElementVNode("i", _hoisted_6, [
                        _createVNode(Location)
                      ]),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(lotInfo.value.neighborhoodName), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                lotInfo.value.lot.marketing_headline &&
                ![
                  _unref(availableStatus).SOLD,
                  _unref(Status).SOLD_CLOSED,
                  _unref(Status).SOLD_CONTINGENCY,
                  _unref(Status).SOLD_PENDING,
                  _unref(Status).RESERVED,
                  _unref(Status).RESERVED_LOT_HOLD,
                ].includes(lotInfo.value.lot.status)
              )
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(lotInfo.value.lot.marketing_headline), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (
              [_unref(availableStatus).AVAILABLE, _unref(availableStatus).FUTURE_HOME].includes(
                lotInfo.value.lot.status
              )
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", _hoisted_10, null, 512), [
                      [_vShow, lotInfo.value.homes_plans.length]
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_11, [
                      (!showFutureHomePlanLabel.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(`${lotInfo.value.homes_plans.length || 0} home plans available`), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "Home Plans"))
                    ], 512), [
                      [_vShow, showHomePlanLabel.value]
                    ]),
                    (lotInfo.value.homes_plans.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (!!lotInfo.value.homes_plans.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "tab-slider",
                                style: _normalizeStyle({ display: loading.value ? 'none' : '' })
                              }, [
                                (!!lotInfo.value.homes_plans.length)
                                  ? (_openBlock(), _createBlock(_unref(Carousel), _mergeProps({
                                      key: 0,
                                      ref_key: "slick",
                                      ref: slick
                                    }, sliderOptions.value), {
                                      addons: _withCtx(() => [
                                        (!showFutureHomePlanLabel.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _createVNode(_unref(Navigation))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lotInfo.value.homes_plans, (homePlan) => {
                                          return (_openBlock(), _createBlock(_unref(Slide), {
                                            key: homePlan.id
                                          }, {
                                            default: _withCtx(() => [
                                              (!!homePlan.image_url.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createVNode(LazyImage, {
                                                      src: imageSource(homePlan.image_url[0]),
                                                      alt: 
                          !!homePlan.image_url.length
                            ? homePlan.image_url[0].caption
                            : homePlan.name
                        ,
                                                      isNeighborhoodImage: false,
                                                      showDefaultImage: showDefaultImage.value
                                                    }, null, 8, ["src", "alt", "showDefaultImage"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (!!!homePlan.image_url.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                    _createVNode(LazyImage, {
                                                      src: imageSource(''),
                                                      alt: homePlan.name,
                                                      isNeighborhoodImage: false,
                                                      showDefaultImage: showDefaultImage.value
                                                    }, null, 8, ["src", "alt", "showDefaultImage"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("h2", {
                                                  class: "homePlan-name",
                                                  onClick: ($event: any) => (
                          !_unref(isKioskMode)
                            ? openPlanDetails(homePlan.plan_url)
                            : openKioskPlanView(homePlan.id)
                        ),
                                                  style: {"cursor":"pointer"}
                                                }, [
                                                  _createTextVNode(_toDisplayString(homePlan.name) + " ", 1),
                                                  (
                            [_unref(availableStatus).FUTURE_HOME].includes(
                              lotInfo.value.lot.status
                            )
                          )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(homePlan.elevation), 1))
                                                    : _createCommentVNode("", true)
                                                ], 8, _hoisted_18),
                                                _createElementVNode("div", _hoisted_20, [
                                                  (
                            !!homePlan.price_high &&
                            ![_unref(availableStatus).FUTURE_HOME].includes(
                              lotInfo.value.lot.status
                            )
                          )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Starts at"))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_22, [
                                                    (
                              [_unref(availableStatus).AVAILABLE].includes(
                                lotInfo.value.lot.status
                              ) && homePlan.price_low !== 0
                            )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(formatPrice)(
                                lotInfo.value.lot.net_premium + homePlan.price_low
                              )), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("p", _hoisted_24, [
                                                (!!homePlan.sqft_low || !!homePlan.sqft_high)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                                      (
                            checkLowRange('sqft_low', 'sqft_high', homePlan)
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(formatSquareFeet(homePlan.sqft_low)), 1))
                                                        : _createCommentVNode("", true),
                                                      (isRange(homePlan.sqft_low, homePlan.sqft_high))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.sqft_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(formatSquareFeet(homePlan.sqft_high)), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[5] || (_cache[5] = _createTextVNode(" sq. ft. | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (!!homePlan.stories_low || !!homePlan.stories_high)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                                      (
                            checkLowRange(
                              'stories_low',
                              'stories_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(homePlan.stories_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(homePlan.stories_low, homePlan.stories_high)
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.stories_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(homePlan.stories_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[6] || (_cache[6] = _createTextVNode(" story | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.bedrooms_low || !!homePlan.bedrooms_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                                      (
                            checkLowRange(
                              'bedrooms_low',
                              'bedrooms_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(homePlan.bedrooms_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(
                              homePlan.bedrooms_low,
                              homePlan.bedrooms_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.bedrooms_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(homePlan.bedrooms_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[7] || (_cache[7] = _createTextVNode(" bed | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.fullbaths_low || !!homePlan.fullbaths_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                                      (
                            checkLowRange(
                              'fullbaths_low',
                              'fullbaths_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(homePlan.fullbaths_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(
                              homePlan.fullbaths_low,
                              homePlan.fullbaths_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.fullbaths_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(homePlan.fullbaths_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[8] || (_cache[8] = _createTextVNode(" full baths | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.halfbaths_low || !!homePlan.halfbaths_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                                      (
                            checkLowRangeHalfBath(
                              'halfbaths_low',
                              'halfbaths_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(homePlan.halfbaths_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRangeHalfBath(
                              homePlan.halfbaths_low,
                              homePlan.halfbaths_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.halfbaths_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(homePlan.halfbaths_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[9] || (_cache[9] = _createTextVNode(" half baths | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.garagebays_low ||
                          !!homePlan.garagebays_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                                      (
                            checkLowRange(
                              'garagebays_low',
                              'garagebays_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(homePlan.garagebays_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(
                              homePlan.garagebays_low,
                              homePlan.garagebays_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.garagebays_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(homePlan.garagebays_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[10] || (_cache[10] = _createTextVNode(" car garage ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 16))
                                  : _createCommentVNode("", true)
                              ], 4))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "tabs",
                      id: "tabtwo",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSiteReInit()))
                    }, null, 512), [
                      [_vShow, !!lotInfo.value.lot.images.length]
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_50, "Site photos", 512), [
                      [_vShow, !!lotInfo.value.lot.images.length]
                    ]),
                    (!!lotInfo.value.lot.images.length && isSiteTabActive.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            (!!lotInfo.value.lot.images.length)
                              ? (_openBlock(), _createBlock(_unref(Carousel), _mergeProps({
                                  key: 
                    lotInfo.value.lot.images.map((img) => img.seq_position).join('-')
                  ,
                                  ref_key: "siteSlick",
                                  ref: siteSlick
                                }, sliderOptions.value), {
                                  addons: _withCtx(() => [
                                    (lotInfo.value.lot.images.length > 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                          _createVNode(_unref(Navigation))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lotInfo.value.lot.images, (image) => {
                                      return (_openBlock(), _createBlock(_unref(Slide), {
                                        key: image.seq_position
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(LazyImage, {
                                            src: imageSource(image),
                                            alt: image.caption,
                                            isNeighborhoodImage: false
                                          }, null, 8, ["src", "alt"]),
                                          (!!image.caption)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(image.caption), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 16))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("h2", _hoisted_56, _toDisplayString(messages.value.sitePhotosH3Message), 1)
                          ]),
                          _createElementVNode("p", _hoisted_57, _toDisplayString(messages.value.sitePhotosPMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (
              [
                _unref(availableStatus).QUICK_MOVE_IN,
                _unref(availableStatus).QMI,
                _unref(availableStatus).MODEL,
              ].includes(lotInfo.value.lot.status)
            )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (lotInfo.value.homes_plans[0]?.move_in_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Move-in date: " + _toDisplayString(new Date() >= new Date(lotInfo.value.homes_plans[0]?.move_in_date)
                  ? 'Immediate'
                  : formatDate(lotInfo.value.homes_plans[0]?.move_in_date)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass({ tabs: lotStatus.value == 'qmi' })
                      }, [
                        _withDirectives(_createElementVNode("input", _hoisted_59, null, 512), [
                          [_vShow, lotStatus.value == 'qmi' && lotInfo.value.homes_plans.length]
                        ]),
                        _withDirectives(_createElementVNode("label", _hoisted_60, "Home Plans", 512), [
                          [_vShow, lotStatus.value == 'qmi' && lotInfo.value.homes_plans.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lotInfo.value.homes_plans, (homePlan) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "tab",
                            key: homePlan.id
                          }, [
                            (![_unref(availableStatus).QMI, _unref(availableStatus).QUICK_MOVE_IN].includes(lotInfo.value.lot.status))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("h2", _mergeProps({ class: "homePlan-name" }, _toHandlers(
                      !_unref(isKioskMode) && homePlan.plan_url
                        ? { click: () => openPlanDetails(homePlan.plan_url) }
                        : undefined
                    , true), {
                                    style: [
                      !_unref(isKioskMode)
                        ? { cursor: 'pointer' }
                        : { pointerEvents: 'none', textDecoration: 'none' },
                    ]
                                  }), [
                                    _createElementVNode("span", null, _toDisplayString(_unref(convertToTitleCase)(homePlan.name)), 1),
                                    (homePlan.elevation)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, " " + _toDisplayString(homePlan.elevation), 1))
                                      : _createCommentVNode("", true)
                                  ], 16)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_unref(Carousel), _mergeProps({
                                ref_for: true,
                                ref_key: "slick",
                                ref: slick
                              }, { ref_for: true }, sliderOptions.value), {
                                addons: _withCtx(() => [
                                  (homePlan.image_url.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        _createVNode(_unref(Navigation))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homePlan.image_url, (homePlanImage) => {
                                    return (_openBlock(), _createBlock(_unref(Slide), {
                                      key: homePlanImage.seq_position,
                                      class: "tab-slider"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(LazyImage, {
                                          src: imageSource(homePlanImage),
                                          alt: homePlanImage.caption,
                                          isNeighborhoodImage: false
                                        }, null, 8, ["src", "alt"]),
                                        (!!homePlanImage.title)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(homePlanImage.title), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  (!homePlan.image_url.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                        _createVNode(LazyImage, {
                                          src: imageSource(''),
                                          alt: '',
                                          isNeighborhoodImage: false
                                        }, null, 8, ["src"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            ([_unref(availableStatus).QMI, _unref(availableStatus).QUICK_MOVE_IN].includes(lotInfo.value.lot.status))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                  _createElementVNode("h2", {
                                    class: "homePlan-name",
                                    onClick: ($event: any) => (
                      !_unref(isKioskMode)
                        ? openPlanDetails(homePlan.plan_url)
                        : openKioskPlanView(homePlan.id)
                    ),
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(homePlan.name), 1),
                                    (homePlan.elevation)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, " " + _toDisplayString(homePlan.elevation), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_68),
                                  _createElementVNode("div", _hoisted_70, [
                                    (!!homePlan.price_high)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                          (!!homePlan.wasprice)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_unref(formatPrice)(homePlan.wasprice)), 1))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_unref(formatPrice)(homePlan.price_high)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_73, [
                              (
                      [_unref(availableStatus).QMI, _unref(availableStatus).QUICK_MOVE_IN].includes(lotInfo.value.lot.status) &&
                      !!homePlan.target_date
                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(homePlan.target_date), 1))
                                : _createCommentVNode("", true),
                              (!!homePlan.sqft_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                                    _cache[11] || (_cache[11] = _createTextVNode(" Square Ft: ", -1)),
                                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(formatSquareFeet(homePlan.sqft_high)) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.stories_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                                    _cache[13] || (_cache[13] = _createTextVNode(" Story: ", -1)),
                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.stories_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.bedrooms_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                    _cache[15] || (_cache[15] = _createTextVNode(" Bedrooms: ", -1)),
                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.bedrooms_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.fullbaths_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                    _cache[17] || (_cache[17] = _createTextVNode(" Full Baths: ", -1)),
                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.fullbaths_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.halfbaths_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                    _cache[19] || (_cache[19] = _createTextVNode(" Half Baths: ", -1)),
                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.halfbaths_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.garagebays_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                                    _cache[21] || (_cache[21] = _createTextVNode(" Garage: ", -1)),
                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.garagebays_high) + "-car ", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "tabs",
                          id: "tabtwo",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSiteReInit()))
                        }, null, 512), [
                          [_vShow, !!lotInfo.value.lot.images.length && lotStatus.value == 'qmi']
                        ]),
                        _withDirectives(_createElementVNode("label", _hoisted_81, "Site photos", 512), [
                          [_vShow, !!lotInfo.value.lot.images.length && lotStatus.value == 'qmi']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            (!!lotInfo.value.lot.images.length)
                              ? (_openBlock(), _createBlock(_unref(Carousel), _mergeProps({
                                  key: 
                      lotInfo.value.lot.images
                        .map((img) => img.seq_position)
                        .join('-') +
                      '-' +
                      isSiteTabActive.value
                    ,
                                  ref_key: "siteSlick",
                                  ref: siteSlick
                                }, sliderOptions.value), {
                                  addons: _withCtx(() => [
                                    (lotInfo.value.lot.images.length > 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                          _createVNode(_unref(Navigation))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lotInfo.value.lot.images, (image) => {
                                      return (_openBlock(), _createBlock(_unref(Slide), {
                                        key: image.seq_position
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(LazyImage, {
                                            src: imageSource(image),
                                            alt: image.caption,
                                            isNeighborhoodImage: false
                                          }, null, 8, ["src", "alt"]),
                                          (!!image.caption)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_84, _toDisplayString(image.caption), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 16))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("h3", _hoisted_87, _toDisplayString(messages.value.sitePhotosH3Message), 1)
                          ]),
                          _createElementVNode("p", _hoisted_88, _toDisplayString(messages.value.sitePhotosPMessage), 1)
                        ], 512), [
                          [_vShow, !!lotInfo.value.lot.images.length && lotStatus.value == 'qmi']
                        ])
                      ], 2)
                    ], 64))
                  : (
              [
                _unref(availableStatus).SOLD,
                _unref(availableStatus).SOLD_CLOSED,
                _unref(availableStatus).SOLD_CONTINGENCY,
                _unref(availableStatus).SOLD_PENDING,
                _unref(availableStatus).RESERVED_LOT_HOLD,
              ].includes(lotInfo.value.lot.status)
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                        (!!lotInfo.value.homes_plans.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("h2", _hoisted_92, [
                                  _createElementVNode("span", null, _toDisplayString(lotInfo.value.homes_plans[0].name), 1),
                                  (!!lotInfo.value.homes_plans[0].elevation)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_93, "  " + _toDisplayString(lotInfo.value.homes_plans[0].elevation), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (
                  !!lotInfo.value.homes_plans[0].image_url.length &&
                  !!lotInfo.value.homes_plans[0].image_url[0].image_url
                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                    _createElementVNode("div", _hoisted_95, [
                                      _createVNode(LazyImage, {
                                        src: imageSource(lotInfo.value.homes_plans[0].image_url[0]),
                                        alt: lotInfo.value.homes_plans[0].image_url[0].caption,
                                        isNeighborhoodImage: false
                                      }, null, 8, ["src", "alt"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
              (showSoldMessage.value && !_unref(isSalesOrLandView))
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    _createTextVNode(_toDisplayString(trailingText.value[0]) + " ", 1),
                    _createElementVNode("span", {
                      class: "linkScheduleVisit",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (openContactInfo()))
                    }, _toDisplayString(_unref(linkOpenConatactInfo)), 1),
                    _createTextVNode(" " + _toDisplayString(trailingText.value[1]), 1)
                  ]))
                : _createCommentVNode("", true),
              (selfGuidedTourUrl.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: "btn schedule-visit-btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openSelfGuidedTour()))
                  }, " Self Guided Tour "))
                : (!suppressScheduleVisit() && !_unref(isSalesOrLandView))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      class: "btn schedule-visit-btn",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (openContactInfo()))
                    }, " Schedule a Visit "))
                  : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true)
      ]),
      (bottomArrowCondition(`left`, `top`))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
            class: "arrow-pointer arrow-top-left"
          }, null, 4))
        : _createCommentVNode("", true),
      (bottomArrowCondition(`right`, `top`))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
            class: "arrow-pointer arrow-top-right"
          }, null, 4))
        : _createCommentVNode("", true),
      (bottomArrowCondition(`left`, `bottom`))
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
            class: "arrow-pointer arrow-bottom-left"
          }, null, 4))
        : _createCommentVNode("", true),
      (bottomArrowCondition(`right`, `bottom`))
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
            class: "arrow-pointer arrow-bottom-right"
          }, null, 4))
        : _createCommentVNode("", true),
      (hasMobile.value && _unref(underlay))
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            style: _normalizeStyle({ left: `${lotPosition.value.left}px` }),
            class: "arrow-pointer arrow-top"
          }, null, 4))
        : _createCommentVNode("", true),
      (hasTablet.value && _unref(underlay))
        ? (_openBlock(), _createElementBlock("div", {
            key: 6,
            style: _normalizeStyle({ left: `${lotPosition.value.arrowPosition}px` }),
            class: "arrow-pointer arrow-top"
          }, null, 4))
        : _createCommentVNode("", true),
      (isShowModalDownArrowUnderlay.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 7,
            style: _normalizeStyle([{ left: `${lotPosition.value.arrowPosition}px` }]),
            class: "arrow-pointer arrow-bottom"
          }, null, 4))
        : _createCommentVNode("", true)
    ], 16)
  ]))
}
}

})